var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C5.45455 4 1.57273 6.90909 0 11C1.57273 15.0909 5.45455 18 10 18C14.5455 18 18.4273 15.0909 20 11C18.4273 6.90909 14.5455 4 10 4ZM10 15.5455C7.49091 15.5455 5.45455 13.5091 5.45455 11C5.45455 8.49091 7.49091 6.45455 10 6.45455C12.5091 6.45455 14.5455 8.49091 14.5455 11C14.5455 13.5091 12.5091 15.5455 10 15.5455ZM10 8.27273C8.49091 8.27273 7.27273 9.49091 7.27273 11C7.27273 12.5091 8.49091 13.7273 10 13.7273C11.5091 13.7273 12.7273 12.5091 12.7273 11C12.7273 9.49091 11.5091 8.27273 10 8.27273Z",
    fill: "#7075E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHover);
export default __webpack_public_path__ + "static/media/eye-hover.12fc6bc310e741bc2de6771c0c35e5c7.svg";
export { ForwardRef as ReactComponent };